<script>
import 'vue-select/dist/vue-select.css'
import { axiosGetPost } from '@router/axiosGetPost'

export default {
  name: 'CorruptFileButton',
  props: {
    status: { type: [String, Number], default: false },
    modelId: { type: [String, Number], default: null },
    module: { type: [String, Number], default: 'fcl' },
  },
  data() {
    return {}
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    questionToChangeStatus() {
      this.$swal({
        title:
          'Deseas marcar como corrupto \n el request ' + this.modelId + ' ?',
        text: 'Marcara el archivo como corrupto',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Si!',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.value) {
          this.changeStatus()
        } else {
          this.$swal('Cancelled')
        }
      })
    },
    changeStatus() {
      axiosGetPost(
        'post',
        '/requests/changeStatusCorruptFile',
        {
          model_id: this.modelId,
          module: this.module,
        },
        'Hide Request FCL'
      ).then((response) => {
        console.log(response)
        if (response.success) {
          this.$emit('updateStatus')
        } else {
          this.$toastr.e('Attention. Error')
        }
        return response
      })
    },
  },
}
</script>

<template>
  <div>
    <b-dropdown-item href="#" @click="questionToChangeStatus">
      <span v-if="status == false" style="color: #f90c0c">
        <i class="uil uil-file-edit-alt"></i>
        &nbsp; &nbsp; Corrupt File
      </span>
      <span v-else-if="status" style="color: #1a1886">
        <i class="uil uil-file-edit-alt"></i>
        &nbsp; &nbsp; Normal File
      </span>
    </b-dropdown-item>
  </div>
</template>
